module.exports = __webpack_public_path__ + "media/images/icons/outlined/codepen-circle-e5eb6935419f8b97db7b0b8c56c56718.svg";